"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.randomDhtAddress = exports.areEqualPeerDescriptors = exports.toNodeId = exports.toDhtAddressRaw = exports.toDhtAddress = exports.KADEMLIA_ID_LENGTH_IN_BYTES = void 0;
const utils_1 = require("@streamr/utils");
const crypto_1 = __importDefault(require("crypto"));
// https://www.scs.stanford.edu/~dm/home/papers/kpos.pdf
exports.KADEMLIA_ID_LENGTH_IN_BYTES = 20;
const toDhtAddress = (raw) => {
    return (0, utils_1.binaryToHex)(raw);
};
exports.toDhtAddress = toDhtAddress;
const toDhtAddressRaw = (address) => {
    return (0, utils_1.hexToBinary)(address);
};
exports.toDhtAddressRaw = toDhtAddressRaw;
const toNodeId = (peerDescriptor) => {
    return (0, exports.toDhtAddress)(peerDescriptor.nodeId);
};
exports.toNodeId = toNodeId;
const areEqualPeerDescriptors = (peerDescriptor1, peerDescriptor2) => {
    return (0, utils_1.areEqualBinaries)(peerDescriptor1.nodeId, peerDescriptor2.nodeId);
};
exports.areEqualPeerDescriptors = areEqualPeerDescriptors;
const randomDhtAddress = () => {
    return (0, exports.toDhtAddress)(crypto_1.default.randomBytes(exports.KADEMLIA_ID_LENGTH_IN_BYTES));
};
exports.randomDhtAddress = randomDhtAddress;
//# sourceMappingURL=identifiers.js.map